var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-wrapper"},[_c('div',_vm._b({staticClass:"loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-e40 w-e40"},'div',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }